import React from 'react';
import {Button, Stack, Typography} from '@mui/material';
import {useParams} from 'react-router-dom';
import {useNotifyIssueBySlackMutation} from '../../features/coreApi/apiSlice';
import {useSelector} from 'react-redux';
import {getEmail} from '../../app/store/reducers/session';

export const residentInfoGrey = '#787878';

export const findEmailSummaryStats = (data) => {
    let totalOpened = 0;
    let totalClicked = 0;

    data.forEach((ele) => {
        if (ele.opened) {
            totalOpened++;
        }

        if (ele.clicked) {
            totalClicked++;
        }
    });

    const openRate = Math.round((totalOpened / data.length) * 100);
    const clickRate = Math.round((totalClicked / data.length) * 100);

    return {
        openRate: openRate,
        clickRate: clickRate
    };
};

export const findTextSummaryStats = (data) => {
    let totalDelivered = 0;

    data.forEach((ele) => {
        if (ele.delivered) {
            totalDelivered++;
        }
    });

    const deliveryRate = Math.round((totalDelivered / data.length) * 100);

    return {
        deliveryRate: deliveryRate
    };
};
export const findPushSummaryStats = (data) => {
    let totalClicked = 0;
    let totalDelivered = 0;

    data.forEach((ele) => {
        if (ele.delivered) {
            totalDelivered++;
        }

        if (ele.clicked) {
            totalClicked++;
        }
    });

    const deliveryRate = Math.round((totalDelivered / data.length) * 100);
    const clickRate = Math.round((totalClicked / data.length) * 100);

    return {
        deliveryRate: deliveryRate,
        clickRate: clickRate
    };
};

export const NotStakeEscrowStatuses = new Set(['ApplicationApproved', 'DebitCardRequested', 'DebitCardActivated']);

export const NotifyIssueBySlack = ({msg, type}) => {
    const params = useParams();
    const communitySfid = params?.community_sfid;
    const accountSfid = params?.account_sfid;
    const email = useSelector(getEmail);

    const [sendNotifyIssueBySlack, {isLoading}] = useNotifyIssueBySlackMutation();

    const handleClick = () => {
        const data = {
            team_member: email,
            issue_type: type,
            issue_description: msg,
            account_sfid: accountSfid,
            building_sfid: communitySfid
        };

        sendNotifyIssueBySlack(data);
    };

    return (
        <Stack direction={'column'} rowGap={1} sx={{height: 200, justifyContent: 'center', alignItems: 'center'}}>
            <Stack direction={'column'} sx={{textAlign: 'center'}}>
                <Typography color={'text.subtitle'}>{msg}.</Typography>
                <Typography color={'text.subtitle'}>
                    If you believe this is an error, please notify the support team by clicking the button below.
                </Typography>
            </Stack>
            <Button variant={'text'} color={'secondary'} onClick={handleClick}>
                Flag an issue
            </Button>
        </Stack>
    );
};
